<template>
  <div>

  </div>
</template>

<script>

export default {
  name: 'Dashboard',
  components: {
    
  },
  data() {
    return {
      
    };
  },
  mounted() {
    const { from } = this.$route.params;

    if (from && from === 'counselor-not-found') {
      this.$store.commit('setGlobalAlert', {
        msg: 'Counselor not found. Please try again!', error: true,
      });
    } else if (from && from === 'student-not-found') {
      this.$store.commit('setGlobalAlert', {
        msg: 'Student not found. Please try again!', error: true,
      });
    } else if (from && from === 'event-scheduled') {
      this.$store.commit('setGlobalAlert', {
        msg: 'Session has been requested! You will be notified when the session has been accepted.',
      });
    } else if (from && from === 'calendar-failure') {
      return this.$store.commit('setGlobalAlert', {
        msg: 'Failed to sync Calendar. Please try again!', error: true,
      });
    }

    if (this.$store.getters.currentUser.isCounselor) {
      if (this.$store.getters.currentUser.counselor_profile.has_set_working_hours) {
        this.$router.replace({name: 'counselor-dashboard'});
      } else {
        this.$router.replace({name: 'availability'});
      }
    } else if (this.$store.getters.currentUser.isAdmin) {
      this.$router.replace({name: 'admin-dashboard'});
    } else if (this.$store.getters.currentUser.isCollegeAdmin) {
      this.$router.replace({name: 'college-dashboard'});
    } else {
      this.$router.replace({name: 'student-dashboard'});
    }
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>
